export function isResponseFailed(response) {
  return !response || !response.status || response.status >= 400
}
